import AmexPlatinumNightsBenefitsCardRefresh from './AmexPlatinumNightsBenefitsCardRefresh';

export default AmexPlatinumNightsBenefitsCardRefresh;
